(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video-responsive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const addQueryListener = (query, callback) => {
      if (query.addEventListener) {
        query.addEventListener('change', callback);
      } else {
        query.addListener(callback);
      }
    };

    const initializeVideo = (video) => {
      if (video.dataset.heroVideoInitialized === 'true') return;

      video.dataset.heroVideoInitialized = 'true';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      const playbackRate = Number.parseFloat(video.dataset.playbackRate) || 1;

      const applyPlaybackRate = () => {
        video.defaultPlaybackRate = playbackRate;
        video.playbackRate = playbackRate;
      };

      const syncVideo = () => {
        if (reducedMotionQuery.matches) {
          video.pause();
          video.removeAttribute('src');
          video.load();
          video.classList.remove('is-ready');
          return;
        }

        const desktopSource = video.dataset.desktopSrc;
        const mobileSource = video.dataset.mobileSrc;
        const selectedSource = mobileQuery.matches
          ? mobileSource || desktopSource
          : desktopSource || mobileSource;

        if (!selectedSource) return;

        if (video.getAttribute('src') !== selectedSource) {
          video.classList.remove('is-ready');
          video.src = selectedSource;
          video.load();
        }

        applyPlaybackRate();
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      };

      video.addEventListener('loadedmetadata', applyPlaybackRate);

      video.addEventListener('loadeddata', () => {
        applyPlaybackRate();
        video.classList.add('is-ready');
      });

      addQueryListener(mobileQuery, syncVideo);
      addQueryListener(reducedMotionQuery, syncVideo);
      syncVideo();
    };

    const initializeHeroVideos = (root = document) => {
      root.querySelectorAll('[data-responsive-hero-video]').forEach(initializeVideo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeHeroVideos());
    } else {
      initializeHeroVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeHeroVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
